function formatTimestamp(ts) {
  const date = new Date(ts * 1000);
  const monthNames = [
    'янв.',
    'фев.',
    'мар.',
    'апр.',
    'мая',
    'июня',
    'июля',
    'авг.',
    'сен.',
    'окт.',
    'ноя.',
    'дек.',
  ];
  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
}

export default formatTimestamp;
